import { useSearchParams } from 'react-router-dom';
import { CreatorDiscoveryTab } from './CreatorDiscoveryTab';
import { IntakeSubmissionsTab } from './IntakeSubmissionsTab';
import { ActiveCreatorsTab } from './ActiveCreatorsTab';
import { AdminTabBar, type AdminTab } from './AdminTabBar';

const TABS: readonly AdminTab[] = ['discovery', 'intake', 'active'] as const;

export function DashboardPage() {
  const [params] = useSearchParams();
  const raw = params.get('tab');
  const tab: AdminTab = (TABS as readonly string[]).includes(raw ?? '')
    ? (raw as AdminTab)
    : 'discovery';

  return (
    <>
      <AdminTabBar />
      {tab === 'discovery' && <CreatorDiscoveryTab />}
      {tab === 'intake' && <IntakeSubmissionsTab />}
      {tab === 'active' && <ActiveCreatorsTab />}
    </>
  );
}
